module.exports = __webpack_public_path__ + "img/order-checked.6ad50f93.png";